export default "__VITE_ASSET__D6lon6rI__"